(function() {
    // DOM Elements
    let modal, iframe, container, loading;
    let videoPlayer, videoContainer, downloadBtn;
    let playPauseBtn, muteBtn, volumeSlider, progressBar, progressFilled, bufferedBar, timeDisplay, bigPlayBtn, bigPlayIcon;
    let skipBackwardBtn, skipForwardBtn, fullscreenBtn, pipBtn, speedBtn, speedText, progressTooltip;
    let speedOptions;

    // State
    let isDragging = false;
    let hideControlsTimeout = null;
    let isInitialized = false;

    function initElements() {
        if (isInitialized) return;

        modal = document.getElementById('video-modal');
        iframe = document.getElementById('modal-video-iframe');
        container = document.getElementById('modal-container');
        loading = document.getElementById('video-loading');

        videoPlayer = document.getElementById('modal-video-player');
        videoContainer = document.getElementById('modal-video-player-container');
        downloadBtn = document.getElementById('download-video-btn');

        playPauseBtn = document.getElementById('play-pause-btn');
        muteBtn = document.getElementById('mute-btn');
        volumeSlider = document.getElementById('volume-slider');
        progressBar = document.getElementById('video-progress-bar');
        progressFilled = document.getElementById('video-progress-filled');
        bufferedBar = document.getElementById('video-buffered');
        timeDisplay = document.getElementById('video-time');
        bigPlayBtn = document.getElementById('big-play-btn');
        bigPlayIcon = document.getElementById('big-play-icon');
        progressTooltip = document.getElementById('progress-tooltip');

        skipBackwardBtn = document.getElementById('skip-backward-btn');
        skipForwardBtn = document.getElementById('skip-forward-btn');
        fullscreenBtn = document.getElementById('fullscreen-btn');
        pipBtn = document.getElementById('pip-btn');
        speedBtn = document.getElementById('speed-btn');
        speedText = document.getElementById('speed-text');
        speedOptions = document.querySelectorAll('.speed-option');

        setupEventListeners();
        isInitialized = true;
    }

    function setupEventListeners() {
        if (!videoPlayer) return;

        // Play/Pause
        if (playPauseBtn) playPauseBtn.addEventListener('click', togglePlayPause);
        if (bigPlayBtn) bigPlayBtn.addEventListener('click', togglePlayPause);
        videoPlayer.addEventListener('click', togglePlayPause);
        videoPlayer.addEventListener('dblclick', toggleFullscreen);

        // Video state events
        videoPlayer.addEventListener('play', onPlay);
        videoPlayer.addEventListener('pause', onPause);
        videoPlayer.addEventListener('ended', onEnded);
        videoPlayer.addEventListener('timeupdate', updateProgress);
        videoPlayer.addEventListener('progress', updateBuffered);
        videoPlayer.addEventListener('loadedmetadata', onMetadataLoaded);
        videoPlayer.addEventListener('waiting', showLoading);
        videoPlayer.addEventListener('canplay', hideLoading);

        // Volume
        if (muteBtn) muteBtn.addEventListener('click', toggleMute);
        if (volumeSlider) {
            volumeSlider.addEventListener('input', handleVolumeChange);
            updateVolumeSliderFill();
        }

        // Progress Bar
        if (progressBar) {
            progressBar.addEventListener('click', seek);
            progressBar.addEventListener('mousedown', startDragging);
            progressBar.addEventListener('mousemove', showProgressTooltip);
            progressBar.addEventListener('mouseleave', hideProgressTooltip);
            document.addEventListener('mousemove', handleDragging);
            document.addEventListener('mouseup', stopDragging);

            // Touch support
            progressBar.addEventListener('touchstart', startDragging);
            progressBar.addEventListener('touchmove', handleTouchDragging);
            progressBar.addEventListener('touchend', stopDragging);
        }

        // Skip buttons
        if (skipBackwardBtn) skipBackwardBtn.addEventListener('click', () => skip(-10));
        if (skipForwardBtn) skipForwardBtn.addEventListener('click', () => skip(10));

        // Fullscreen
        if (fullscreenBtn) fullscreenBtn.addEventListener('click', toggleFullscreen);
        document.addEventListener('fullscreenchange', updateFullscreenButton);

        // Picture in Picture
        if (pipBtn) pipBtn.addEventListener('click', togglePiP);

        // Playback speed
        if (speedOptions) {
            speedOptions.forEach(option => {
                option.addEventListener('click', (e) => {
                    const speed = parseFloat(e.target.dataset.speed);
                    setPlaybackSpeed(speed);
                });
            });
        }

        // Controls visibility
        if (videoContainer) {
            videoContainer.addEventListener('mousemove', showControls);
            videoContainer.addEventListener('mouseleave', scheduleHideControls);
        }

        // Keyboard shortcuts
        document.addEventListener('keydown', handleKeyboard);
    }

    // Playback controls
    function togglePlayPause(e) {
        if (e) e.stopPropagation();
        if (!videoPlayer) return;

        if (videoPlayer.paused || videoPlayer.ended) {
            videoPlayer.play().catch(console.error);
        } else {
            videoPlayer.pause();
        }
    }

    function onPlay() {
        updatePlayPauseButton(false);
        if (videoContainer) {
            videoContainer.classList.add('playing');
            videoContainer.classList.remove('paused');
        }
        scheduleHideControls();
    }

    function onPause() {
        updatePlayPauseButton(true);
        if (videoContainer) {
            videoContainer.classList.remove('playing');
            videoContainer.classList.add('paused');
        }
        showControls();
    }

    function onEnded() {
        videoPlayer.currentTime = 0;
        updatePlayPauseButton(true);
        if (videoContainer) {
            videoContainer.classList.remove('playing');
            videoContainer.classList.add('paused');
        }
        showControls();
    }

    function updatePlayPauseButton(isPaused) {
        if (playPauseBtn) {
            const icon = playPauseBtn.querySelector('i');
            if (icon) {
                if (isPaused) {
                    icon.classList.remove('fa-pause');
                    icon.classList.add('fa-play');
                } else {
                    icon.classList.remove('fa-play');
                    icon.classList.add('fa-pause');
                }
            }
        }

        if (bigPlayBtn && bigPlayIcon) {
            if (isPaused) {
                bigPlayBtn.style.opacity = '1';
                bigPlayBtn.style.pointerEvents = 'auto';
                bigPlayIcon.classList.remove('fa-pause');
                bigPlayIcon.classList.add('fa-play');
            } else {
                bigPlayBtn.style.opacity = '0';
                bigPlayBtn.style.pointerEvents = 'none';
                bigPlayIcon.classList.remove('fa-play');
                bigPlayIcon.classList.add('fa-pause');
            }
        }
    }

    // Progress
    function updateProgress() {
        if (!progressFilled || !videoPlayer.duration) return;
        const percent = (videoPlayer.currentTime / videoPlayer.duration) * 100;
        progressFilled.style.width = `${percent}%`;
        updateTimeDisplay();
    }

    function updateBuffered() {
        if (!bufferedBar || !videoPlayer.buffered.length) return;
        const bufferedEnd = videoPlayer.buffered.end(videoPlayer.buffered.length - 1);
        const percent = (bufferedEnd / videoPlayer.duration) * 100;
        bufferedBar.style.width = `${percent}%`;
    }

    function startDragging(e) {
        isDragging = true;
        seek(e);
    }

    function handleDragging(e) {
        if (isDragging) seek(e);
    }

    function handleTouchDragging(e) {
        if (isDragging && e.touches[0]) {
            const touch = e.touches[0];
            seek({ clientX: touch.clientX });
        }
    }

    function stopDragging() {
        isDragging = false;
    }

    function seek(e) {
        if (!progressBar || !videoPlayer.duration) return;
        const rect = progressBar.getBoundingClientRect();
        const clientX = e.clientX || (e.touches && e.touches[0]?.clientX);
        if (!clientX) return;

        let pos = (clientX - rect.left) / rect.width;
        pos = Math.max(0, Math.min(1, pos));
        videoPlayer.currentTime = pos * videoPlayer.duration;
    }

    function showProgressTooltip(e) {
        if (!progressTooltip || !progressBar || !videoPlayer.duration) return;
        const rect = progressBar.getBoundingClientRect();
        let pos = (e.clientX - rect.left) / rect.width;
        pos = Math.max(0, Math.min(1, pos));

        const time = pos * videoPlayer.duration;
        progressTooltip.textContent = formatTime(time);
        progressTooltip.style.left = `${pos * 100}%`;
        progressTooltip.style.opacity = '1';
    }

    function hideProgressTooltip() {
        if (progressTooltip) {
            progressTooltip.style.opacity = '0';
        }
    }

    // Volume
    function toggleMute() {
        if (!videoPlayer) return;
        videoPlayer.muted = !videoPlayer.muted;
        updateVolumeIcon();
        if (volumeSlider) {
            volumeSlider.value = videoPlayer.muted ? 0 : videoPlayer.volume;
            updateVolumeSliderFill();
        }
    }

    function handleVolumeChange(e) {
        if (!videoPlayer) return;
        const value = parseFloat(e.target.value);
        videoPlayer.volume = value;
        videoPlayer.muted = value === 0;
        updateVolumeIcon();
        updateVolumeSliderFill();
    }

    function updateVolumeIcon() {
        if (!muteBtn || !videoPlayer) return;
        const icon = muteBtn.querySelector('i');
        if (!icon) return;
        if (videoPlayer.muted || videoPlayer.volume === 0) {
            icon.className = 'text-sm fas fa-volume-mute';
        } else if (videoPlayer.volume < 0.5) {
            icon.className = 'text-sm fas fa-volume-down';
        } else {
            icon.className = 'text-sm fas fa-volume-up';
        }
    }

    function updateVolumeSliderFill() {
        if (!volumeSlider) return;
        const percent = volumeSlider.value * 100;
        volumeSlider.style.setProperty('--volume-percent', `${percent}%`);
    }

    // Time
    function updateTimeDisplay() {
        if (!timeDisplay || !videoPlayer) return;
        const current = formatTime(videoPlayer.currentTime);
        const duration = formatTime(videoPlayer.duration || 0);
        timeDisplay.textContent = `${current} / ${duration}`;
    }

    function formatTime(seconds) {
        if (isNaN(seconds) || !isFinite(seconds)) return '00:00';
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);

        if (h > 0) {
            return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
        }
        return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }

    // Skip
    function skip(seconds) {
        if (!videoPlayer) return;
        videoPlayer.currentTime = Math.max(0, Math.min(videoPlayer.duration, videoPlayer.currentTime + seconds));
    }

    // Playback speed
    function setPlaybackSpeed(speed) {
        if (!videoPlayer) return;
        videoPlayer.playbackRate = speed;
        if (speedText) speedText.textContent = `${speed}x`;

        speedOptions.forEach(opt => {
            opt.classList.toggle('text-red-400', parseFloat(opt.dataset.speed) === speed);
        });
    }

    // Fullscreen
    function toggleFullscreen() {
        if (!videoContainer) return;

        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            videoContainer.requestFullscreen().catch(console.error);
        }
    }

    function updateFullscreenButton() {
        if (!fullscreenBtn) return;
        const icon = fullscreenBtn.querySelector('i');
        if (!icon) return;
        if (document.fullscreenElement) {
            icon.classList.remove('fa-expand');
            icon.classList.add('fa-compress');
        } else {
            icon.classList.remove('fa-compress');
            icon.classList.add('fa-expand');
        }
    }

    // Picture in Picture
    function togglePiP() {
        if (!videoPlayer) return;
        if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
        } else if (document.pictureInPictureEnabled) {
            videoPlayer.requestPictureInPicture().catch(console.error);
        }
    }

    // Controls visibility
    function showControls() {
        if (videoContainer) {
            videoContainer.classList.add('controls-visible');
        }
        clearTimeout(hideControlsTimeout);
        if (!videoPlayer?.paused) {
            scheduleHideControls();
        }
    }

    function scheduleHideControls() {
        clearTimeout(hideControlsTimeout);
        hideControlsTimeout = setTimeout(() => {
            if (videoContainer && !videoPlayer?.paused) {
                videoContainer.classList.remove('controls-visible');
            }
        }, 3000);
    }

    // Loading states
    function showLoading() {
        if (loading) loading.style.display = 'flex';
    }

    function hideLoading() {
        if (loading) loading.style.display = 'none';
    }

    function onMetadataLoaded() {
        updateTimeDisplay();
        hideLoading();
    }

    // Keyboard shortcuts
    function handleKeyboard(e) {
        if (!modal || modal.classList.contains('hidden')) return;
        if (videoContainer?.classList.contains('hidden')) return;

        switch(e.key) {
            case ' ':
            case 'k':
                e.preventDefault();
                togglePlayPause();
                break;
            case 'ArrowLeft':
                e.preventDefault();
                skip(-10);
                break;
            case 'ArrowRight':
                e.preventDefault();
                skip(10);
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (videoPlayer) videoPlayer.volume = Math.min(1, videoPlayer.volume + 0.1);
                if (volumeSlider) volumeSlider.value = videoPlayer.volume;
                updateVolumeIcon();
                updateVolumeSliderFill();
                break;
            case 'ArrowDown':
                e.preventDefault();
                if (videoPlayer) videoPlayer.volume = Math.max(0, videoPlayer.volume - 0.1);
                if (volumeSlider) volumeSlider.value = videoPlayer.volume;
                updateVolumeIcon();
                updateVolumeSliderFill();
                break;
            case 'm':
                toggleMute();
                break;
            case 'f':
                toggleFullscreen();
                break;
            case 'Escape':
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else {
                    window.closeVideoModal();
                }
                break;
        }
    }

    // Global functions
    window.hideVideoLoading = function() {
        initElements();
        hideLoading();
        if (iframe && !iframe.classList.contains('hidden')) {
            iframe.classList.remove('opacity-0');
            iframe.classList.add('opacity-100');
        }
    };

    window.openVideoModal = function(videoSource) {
        initElements();

        requestAnimationFrame(() => {
            if (loading) loading.style.display = 'flex';
            if (modal) {
                modal.classList.remove('hidden');
                modal.classList.add('flex');
                document.body.style.overflow = 'hidden';
            }

            // Reset state
            if (speedText) speedText.textContent = '1x';

            // Determine source type
            const isLocal = videoSource.includes('/') || videoSource.endsWith('.mp4') || videoSource.endsWith('.webm');

            if (isLocal) {
                if (iframe) iframe.classList.add('hidden');
                if (videoContainer) {
                    videoContainer.classList.remove('hidden');
                    videoContainer.classList.add('paused');
                    videoContainer.classList.remove('playing');
                }
                if (downloadBtn) {
                    downloadBtn.href = videoSource;
                    downloadBtn.classList.remove('hidden');
                    downloadBtn.classList.add('flex');
                }

                if (videoPlayer) {
                    videoPlayer.src = videoSource;
                    videoPlayer.load();
                    videoPlayer.playbackRate = 1;
                    updatePlayPauseButton(true);
                }
            } else {
                if (videoContainer) videoContainer.classList.add('hidden');
                if (iframe) {
                    iframe.classList.remove('hidden');
                    iframe.classList.add('opacity-0');
                    iframe.classList.remove('opacity-100');
                    iframe.src = `https://www.youtube.com/embed/${videoSource}?autoplay=1&rel=0`;
                }
                if (downloadBtn) {
                    downloadBtn.classList.add('hidden');
                    downloadBtn.classList.remove('flex');
                }
                setTimeout(window.hideVideoLoading, 1500);
            }

            if (container) {
                setTimeout(() => {
                    requestAnimationFrame(() => {
                        container.classList.remove('scale-95', 'opacity-0');
                        container.classList.add('scale-100', 'opacity-100');
                    });
                }, 10);
            }
        });
    };

    window.closeVideoModal = function() {
        initElements();
        document.body.style.overflow = '';

        if (document.fullscreenElement) {
            document.exitFullscreen();
        }

        requestAnimationFrame(() => {
            if (container) {
                container.classList.remove('scale-100', 'opacity-100');
                container.classList.add('scale-95', 'opacity-0');
            }

            if (videoPlayer) {
                videoPlayer.pause();
                videoPlayer.currentTime = 0;
            }

            setTimeout(() => {
                requestAnimationFrame(() => {
                    if (modal) {
                        modal.classList.add('hidden');
                        modal.classList.remove('flex');
                    }
                    if (iframe) iframe.src = '';
                    if (videoPlayer) videoPlayer.src = '';
                    if (progressFilled) progressFilled.style.width = '0%';
                    if (bufferedBar) bufferedBar.style.width = '0%';
                });
            }, 300);
        });
    };

    window.shareVideo = function() {
        initElements();
        const url = window.location.href;
        const titleElement = document.getElementById('video-modal-title');
        const title = titleElement ? titleElement.textContent.trim() : 'Check out this video';

        if (navigator.share) {
            navigator.share({ title, url }).catch(console.error);
        } else {
            navigator.clipboard.writeText(url).then(() => {
                const toast = document.querySelector('[data-toast]');
                if (toast) {
                    toast.textContent = 'Link copied!';
                    toast.classList.add('show');
                    setTimeout(() => toast.classList.remove('show'), 2000);
                } else {
                    alert('Link copied!');
                }
            }).catch(console.error);
        }
    };

    window.toggleFullscreen = toggleFullscreen;
})();
